import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleError, hasError } from '@repo/shared/api/helpers'
import { GenerationCacheOptions } from '@repo/shared/events/generation'

import { buildBeneficiaryFromDto } from '@/external/api/helpers'
import { DashboardWidget } from '@/store/dashboard-widgets/types'

import { AsyncThunkConfig, RejectValue } from '../actions'

export const getWidgetData = createAsyncThunk<
  Pick<DashboardWidget, 'shortList' | 'totalItems'>,
  { widget: DashboardWidget } & GenerationCacheOptions,
  AsyncThunkConfig
>(
  'GET_WIDGET_DATA',
  async ({ widget }, { getState, extra, rejectWithValue, fulfillWithValue }) => {
    const state = getState()
    const organizationId = state.user.currentOrganizationId
    if (!organizationId) return rejectWithValue(RejectValue.NoOrganization)

    const res = await extra.altApi.beneficiaries.search({
      filters: widget.filterTemplate.filters,
      organizationId,
      page: 1,
      perPage: 3,
      scope: 'caseworker',
      sortOption: { field: 'fullName', direction: 'ASC' },
    })
    if (hasError(res)) return rejectWithValue(handleError(res))
    return fulfillWithValue({
      shortList: res.beneficiaries.map(buildBeneficiaryFromDto),
      totalItems: res.meta.totalItems,
    })
  },
  {
    condition: ({ widget, cacheOptions }) => {
      const cacheDelay = 5 * 60 * 1000 // 5 minutes
      const cached: boolean = new Date().getTime() - (widget.lastUpdatedAt || 0) <= cacheDelay
      if (cached && !cacheOptions?.forceReset) {
        // Cached data is still valid
        return false
      }
      return true
    },
  },
)
